module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAWCAYAAAD0OH0aAAAAAXNSR0IArs4c6QAAAMZJREFUOBGt0jsOwjAMBmDbdEE9FBIFDsEFEAwwF2bamQEQF+AQFeVWpQuKwUit2qQPV8JLJOf/kigJwNCaR/lkEedTrSMD5v5m8wiibKVBBAhHYEYGuGoQpaF/QaSdFmFxjCB6bZnNCRD521yne/9WzFXHEkhTg2pAgxzQhxpBF2oFNvKQZkk4fpJMDKlWYN+YrC4LNx7JDlffxAFdYWeHvnANaMIl0IZ/IIizDRs+9306CUsRMBy0YQEeAS0RYVTcszT/Wh9z35cgLCiSVgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrows.png
// module id = XLNb
// module chunks = 0